import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import stringifyParams from "@/utils/stringifyParams";

export const buildRequestUrlToFetchTaxonomyData = (queryParameters: {
  [key: string]: string | number;
}) => `${MONOLITH_ORIGIN}/api/v3/taxonomy/${stringifyParams(queryParameters)}`;
